import React, { Component } from 'react'
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Image from '../../../../../config/images/gambar';
import { DateIndo } from '../../../../../utils/helpers';

export default class PrintBio extends Component {
    state = {
        data: this.props.location.state.dataPrint,
        provinsi: this.props.location.state.provinsi,
        linkFoto: this.props.location.state.linkFoto
    }

    // handle to print 
    print = () => {
        function toBlob(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                var reader = new FileReader();
                reader.onloadend = function () {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        }
        var foto = this.state.linkFoto + this.state.data.foto_mhs
        var profilePhoto = this.state.data.foto_mhs == "" || this.state.data.foto_mhs == null || this.state.data.foto_mhs == undefined ? "/no-image.jpg" : foto
        toBlob(profilePhoto,
            function (dataUrl) {
                if (dataUrl != undefined) {
                    const doc = new jsPDF();

                    var imageAsia = Image.data
                    doc.addImage(imageAsia, 'JPEG', 95, 7, 19, 19)

                    doc.addImage(dataUrl, 'JPEG', 162, 64, 35, 44)

                    var width = doc.internal.pageSize.getWidth()
                    doc.setFont("Times-bold", "bold")
                    doc.setFontSize(11.5);
                    doc.text('INSTITUT TEKNOLOGI DAN BISNIS ASIA MALANG', width / 2, 33, { align: 'center' });
                    doc.setFont("Times-Roman", "normal");
                    doc.setFontSize(11.5);
                    doc.text('Jl. Soekarno-Hatta, Rembuksari 1A Malang Telp.(0341) 478877 Fax.(0341) 4345225', width / 2, 39, { align: 'center' });

                    doc.setLineWidth(0.1)
                    doc.line(10, 43, 200, 43)

                    doc.setFont("Times-bold", "bold");
                    doc.setFontSize(11.5);

                    doc.text('DATA INDUK MAHASISWA', width / 2, 54, { align: 'center' });

                    doc.autoTable({
                        html: '#biodata',
                        startY: doc.lastAutoTable + 63,
                        theme: 'plain',
                        styles: {
                            font: 'times',
                            lineColor: 'black',
                            textColor: 'black',
                            fontSize: '10.5',
                            cellPadding: 0.5
                        },
                        columnStyles: {
                            0: { cellWidth: 40 },
                            1: { cellWidth: 5 },
                        },
                        margin: { left: 12, right: 12 },
                    });

                    doc.autoTable({
                        html: '#ayah',
                        theme: 'plain',
                        styles: {
                            font: 'times',
                            lineColor: 'black',
                            textColor: 'black',
                            fontSize: '10.5',
                            cellPadding: 0.5
                        },
                        columnStyles: {
                            0: { cellWidth: 40 },
                            1: { cellWidth: 5 },
                        },
                        margin: { left: 12, right: 12 },
                    });

                    doc.autoTable({
                        html: '#ibu',
                        theme: 'plain',
                        styles: {
                            font: 'times',
                            lineColor: 'black',
                            textColor: 'black',
                            fontSize: '10.5',
                            cellPadding: 0.5
                        },
                        columnStyles: {
                            0: { cellWidth: 40 },
                            1: { cellWidth: 5 },
                        },
                        margin: { top: 10, left: 12, right: 12, bottom: 10 },
                    });

                    window.open(doc.output('bloburl'), '_blank')
                    window.history.go(-1);
                }
            })
    }

    componentDidMount = () => {
        this.print()
    }

    render() {
        return (
            <div>
                <div id="spinner mt-5" className="loader-1 colorful mt-5 mb-5">
                    <div className="dot" />
                    <div className="dot" />
                    <div className="dot" />
                </div>
                <p style={{ textAlign: 'center', marginTop: '-30px' }}>Print Loading...</p>
                <div style={{ display: 'none' }}>
                    <div>
                        <table id="biodata">
                            <thead></thead>
                            <tbody>
                                <tr>
                                    <td>NIM</td>
                                    <td>:</td>
                                    <td>{this.state.data.nim}</td>
                                </tr>
                                <tr>
                                    <td>Nama</td>
                                    <td>:</td>
                                    <td>{this.state.data.nama}</td>
                                </tr>
                                <tr>
                                    <td>Program Studi</td>
                                    <td>:</td>
                                    <td>{this.state.data.prodi}</td>
                                </tr>
                                <tr>
                                    <td>Jenis Kelamin</td>
                                    <td>:</td>
                                    <td>{this.state.data.gender == 1 ? "Laki-Laki" : "Perempuan"}</td>
                                </tr>
                                <tr>
                                    <td>Tempat, Tanggal Lahir</td>
                                    <td>:</td>
                                    <td>{this.state.data.tempat_lahir}, {DateIndo(this.state.data.tgl_lahir)}</td>
                                </tr>
                                <tr>
                                    <td>Kewarganegaraan</td>
                                    <td>:</td>
                                    <td>{this.state.data.kewarganegaraan}</td>
                                </tr>
                                <tr>
                                    <td>Agama</td>
                                    <td>:</td>
                                    <td>{this.state.data.agama}</td>
                                </tr>
                                <tr>
                                    <td>Email</td>
                                    <td>:</td>
                                    <td>{this.state.data.email}</td>
                                </tr>
                                <tr>
                                    <td>NIK Mahasiswa</td>
                                    <td>:</td>
                                    <td>{this.state.data.nik}</td>
                                </tr>
                                <tr>
                                    <td>NISN</td>
                                    <td>:</td>
                                    <td>{this.state.data.nisn}</td>
                                </tr>
                                <tr>
                                    <td>NPWP</td>
                                    <td>:</td>
                                    <td>{this.state.data.npwp}</td>
                                </tr>
                                <tr>
                                    <td>Jenis Tinggal</td>
                                    <td>:</td>
                                    <td>{this.state.data.jenis_tinggal}</td>
                                </tr>
                                <tr>
                                    <td>Alat Transportasi</td>
                                    <td>:</td>
                                    <td>{this.state.data.alat_transport}</td>
                                </tr>
                                <tr>
                                    <td>Alamat</td>
                                    <td>:</td>
                                    <td>{this.state.data.jalan}</td>
                                </tr>
                                <tr>
                                    <td>Provinsi</td>
                                    <td>:</td>
                                    <td>
                                        {
                                            this.state.provinsi.filter(x => x.i == this.state.data.provinsi).map((list) => {
                                                return list.pname
                                            })
                                        }
                                    </td>
                                </tr>
                                <tr>
                                    <td>Kota/Kab</td>
                                    <td>:</td>
                                    <td>{this.state.data.kab}</td>
                                </tr>
                                <tr>
                                    <td>Kecamatan</td>
                                    <td>:</td>
                                    <td>{this.state.data.kecamatan}</td>
                                </tr>
                                <tr>
                                    <td>Kelurahan/Desa</td>
                                    <td>:</td>
                                    <td>{this.state.data.kelurahan}</td>
                                </tr>
                                <tr>
                                    <td>RT/RW</td>
                                    <td>:</td>
                                    <td>RT.{this.state.data.rt}/{this.state.data.rw}</td>
                                </tr>
                                <tr>
                                    <td>Kode Pos</td>
                                    <td>:</td>
                                    <td>{this.state.data.kdpos}</td>
                                </tr>
                                <tr>
                                    <td>Telepon</td>
                                    <td>:</td>
                                    <td>{this.state.data.nowa}</td>
                                </tr>
                            </tbody>
                        </table>

                        <table id="ayah">
                            <thead></thead>
                            <tbody>
                                <tr>
                                    <td>NIK Ayah</td>
                                    <td>:</td>
                                    <td>{this.state.data.nikayah}</td>
                                </tr>
                                <tr>
                                    <td>Keterangan Hidup</td>
                                    <td>:</td>
                                    <td>{this.state.data.keterangan_hidup_ayah}</td>
                                </tr>
                                <tr>
                                    <td>Nama Ayah</td>
                                    <td>:</td>
                                    <td>{this.state.data.namaayah}</td>
                                </tr>
                                <tr>
                                    <td>Tanggal Lahir</td>
                                    <td>:</td>
                                    <td>{DateIndo(this.state.data.tgl_lahir_ayah)}</td>
                                </tr>
                                <tr>
                                    <td>Pendidikan</td>
                                    <td>:</td>
                                    <td>{this.state.data.pendidikan_ayah}</td>
                                </tr>
                                <tr>
                                    <td>Pekerjaan</td>
                                    <td>:</td>
                                    <td>{this.state.data.pekerjaan_ayah}</td>
                                </tr>
                                <tr>
                                    <td>Telepon</td>
                                    <td>:</td>
                                    <td>{this.state.data.notelp_ayah}</td>
                                </tr>
                            </tbody>
                        </table>

                        <table id="ibu">
                            <thead></thead>
                            <tbody>
                                <tr>
                                    <td>NIK Ibu</td>
                                    <td>:</td>
                                    <td>{this.state.data.nik_ibu}</td>
                                </tr>
                                <tr>
                                    <td>Keterangan Hidup</td>
                                    <td>:</td>
                                    <td>{this.state.data.keterangan_hidup_ibu}</td>
                                </tr>
                                <tr>
                                    <td>Nama Ibu</td>
                                    <td>:</td>
                                    <td>{this.state.data.nama_ibu}</td>
                                </tr>
                                <tr>
                                    <td>Tanggal Lahir</td>
                                    <td>:</td>
                                    <td>{DateIndo(this.state.data.tgl_lahir_ibu)}</td>
                                </tr>
                                <tr>
                                    <td>Pendidikan</td>
                                    <td>:</td>
                                    <td>{this.state.data.pendidikan_ibu}</td>
                                </tr>
                                <tr>
                                    <td>Pekerjaan</td>
                                    <td>:</td>
                                    <td>{this.state.data.pekerjaan_ibu}</td>
                                </tr>
                                <tr>
                                    <td>Telepon</td>
                                    <td>:</td>
                                    <td>{this.state.data.notelp_ibu}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div >
            </div>
        )
    }
}
